const FacebookHollowLogo = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="20" viewBox="0 0 13 20" fill="none">
            <path d="M1 8V12H4V19H8V12H11L12 8H8V6C8 5.44772 8.44772 5 9 5H12V1H9C6.23858 1 4 3.23858 4 6V8H1" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
};

export default FacebookHollowLogo;